import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Less = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M36 20C36 20.5523 35.5523 21 35 21L5 21C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19L35 19C35.5523 19 36 19.4477 36 20Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Less;
